export default __webpack_public_path__ + "static/media/longCloud13.72955224.webp";